var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({attrs:{"append-to-body":"","close-on-click-modal":false,"close-on-press-escape":false,"destroy-on-close":""}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }